import { TableColumn } from './shared/table.constants';

export const PRODUCT_GROUPS_COLUMNS: TableColumn[] = [
  { id: 'actions', title: '', className: 'w-1/12' },
  { id: 'id', title: 'id' },
  { id: 'name', title: 'name' },
  { id: 'group', title: 'product_group', className: 'last:text-left' },
];
